﻿//import cpiStatusMessage from "../statusMessage";
//import * as pageHelper from "../pageHelper";

//manage main buttons (add, delete, search, print, etc..)
(function ($) {
    if (typeof $.fn.cpiMainButtons === "undefined") {
        $.fn.cpiMainButtons = function(options) {
            const plugin = this;

            const defaults = {
                onRefresh: function() {},
                onRefreshOptions: {}
            };
            const settings = $.extend({}, defaults, options);

            //new layout: include page-navs
            plugin.on("click",
                "button, .page-nav",
                function() {
                    const link = $(this);
                    let url = link.data("url");

                    //new layout: hide status message
                    cpiStatusMessage.hide();
                    if (url) {
                        //TODO: 
                        //IF THIS CODE IS STILL NEEDED, 
                        //WE NEED TO MOVE IT OUTSIDE OF THIS PLUGIN!!
                        //if (url.includes("email"))
                        //    url = url + "/" + settings.onRefreshOptions;

                        cpiLoadingSpinner.show();
                        $.get(url).done(function (result) {
                            cpiLoadingSpinner.hide();
                            const parentContainer = link.data("container");

                            //if response should be placed in a popup container
                            const isPopup = link.data("popup");
                            if (isPopup !== undefined && isPopup) {
                                //use one container to avoid duplicate element ids
                                //const popupContainer = $("#" + parentContainer).find(".cpiContainerPopup");
                                const popupContainer = $(".site-content .popup");
                                popupContainer.empty();
                                popupContainer.html(result);
                            }
                            else {
                                //if container is defined, empty content and add the response
                                //otherwise, just append the response to the DOM
                                if (parentContainer !== undefined && parentContainer !== null && parentContainer.length > 0) {
                                    const dataContainer = $('#' + parentContainer).find(".cpiDataContainer");
                                    if (dataContainer.length > 0) {
                                        dataContainer.empty();
                                        dataContainer.html(result);
                                    }
                                }
                                else
                                    pageHelper.appendPage(result);
                            }
                        }).fail(function (e) {
                            cpiLoadingSpinner.hide();
                            pageHelper.showErrors(e);
                        });

                        
                    } else if (link.hasClass("refresh-record")) { //record refresh
                        settings.onRefresh(settings.onRefreshOptions);
                    }
                });
            return this;
        };
    }
})(jQuery);
